import { FormProvider, useForm } from 'react-hook-form';
import { useSpreedlyHosted } from '../spreedly-payment-hosted.hooks';
import { useURLSearchParams } from 'hooks/useURLSearchParams';
import { useMobileAppListeners } from 'hooks/mobileAppListeners/useMobileAppListeners';
import SpreedlyPaymentHostedWrapper from '../spreedly-payment-hosted-wrapper.component';
import SpreedlyCVVRecacheForm from 'components/payment/spreedly/spreedly-card/forms/spreedly-cvv-recache-form/spreedly-cvv-recache-form.component';
import { getRecacheError } from 'components/payment/spreedly/spreedly-card/forms/spreedly-cvv-recache-form/spreedly-cvv-recache-form.utils';

const SpreedlyCVVRecacheHosted = () => {
  const { initOrderResponse, loading, setLoading, spreedlyScriptLoading } =
    useSpreedlyHosted();

  const urlSearchParams = useURLSearchParams();

  const paymentInstrument = {
    paymentToken: urlSearchParams.get('paymentToken'),
    cardType: urlSearchParams.get('cardType'),
    lastFour: urlSearchParams.get('lastFour'),
  };

  const fireListeners = useMobileAppListeners();

  const onSuccess = () => {
    fireListeners('CVV Verification success');
    setLoading(false);
  };

  const onError = errors => {
    fireListeners(getRecacheError(errors));
    setLoading(false);
  };

  const methods = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });

  return (
    <SpreedlyPaymentHostedWrapper isLoading={spreedlyScriptLoading}>
      <FormProvider {...methods}>
        {!!initOrderResponse && (
          <SpreedlyCVVRecacheForm
            paymentInstrument={paymentInstrument}
            initOrderAttributes={initOrderResponse?.attributes}
            onSuccess={onSuccess}
            onError={onError}
            setLoading={setLoading}
            isLoading={loading}
          />
        )}
      </FormProvider>
    </SpreedlyPaymentHostedWrapper>
  );
};

export default SpreedlyCVVRecacheHosted;
